import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
// import { toIdValue } from 'apollo-utilities';
import { split, from } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
import { onError } from 'apollo-link-error';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { BatchHttpLink } from 'apollo-link-batch-http';

import config from '../config';

export const subscriptionClient = new SubscriptionClient(config.apolloWsHost, {
  reconnect: true,
  connectionParams: {
    authToken: localStorage.getItem('accessToken'),
    uuid: sessionStorage.getItem('uuid'),
  },
});

function createClient({ store }) {
  // Create an http link:
  const httpLink = new BatchHttpLink({
    uri: config.apolloHost,
  });

  // Create a WebSocket link:
  const wsLink = new WebSocketLink(subscriptionClient);

  const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem('accessToken');
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : null,
      },
    };
  });

  const redboxErrorLink = onError(
    ({ networkError, graphQLErrors, operation }) => {
      const errors = networkError
        ? [networkError.message]
        : graphQLErrors.map(e => e.message);
      store.dispatch({
        type: 'APOLLO-FAILURE',
        error: {
          json: {
            errors,
          },
        },
      });
    },
  );

  // using the ability to split links, you can send data to each link
  // depending on what kind of operation is being sent
  const link = split(
    // split based on operation type
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query);
      return kind === 'OperationDefinition' && operation === 'subscription';
    },
    wsLink,
    // authLink.concat(httpLink),
    from([redboxErrorLink, authLink, httpLink]),
  );

  const cache = new InMemoryCache({
    // cacheResolvers: {
    //   Query: {
    //     // comments: (_, { id }) => {
    //     //   debugger;
    //     //   return toIdValue(
    //     //     cache.config.dataIdFromObject({ __typename: 'Comment', id }),
    //     //   );
    //     // },
    //     Comment: (_, { id }) => {
    //       debugger;
    //       return toIdValue(
    //         cache.config.dataIdFromObject({ __typename: 'Comment', id }),
    //       );
    //     },
    //   },
    // },
  });

  const client = new ApolloClient({
    link, //: from([link, redboxErrorLink]),
    cache,
  });

  return client;
}

export function browserClient(params) {
  return createClient(params);
}



// WEBPACK FOOTER //
// ./src/apollo/index.js